import { useEffect } from "react";
import { Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";

import { ItemInfoBlock } from "components";
import { useStores } from "stores";
import { WhiteBoxBlock } from "ui";
import { getColumns } from "./getColumns";
import { MarkdownButton } from "components/Markdown";
import { MarkdownBox } from "components/Markdown/MarkdownBox";
import { VersionInfo } from "./Version";

export const InformationPage = observer(() => {
  const { settings, user } = useStores();

  const { isSystemAdmin } = user.roles;

  useEffect(() => {
    settings.fetchRates();
    settings.fetchSettingsInfoText();

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [settings]);

  return (
    <Flex vertical gap="large">
      <Typography.Title className="margin-none">Информация</Typography.Title>
      <Flex gap="large" wrap>
        <div style={{ flex: 1 }}>
          <WhiteBoxBlock id="info-time-block">
            <Flex vertical gap="middle">
              <MarkdownBox markdownText={settings.infoText} />
              {isSystemAdmin && <MarkdownButton />}
            </Flex>
          </WhiteBoxBlock>
        </div>

        <Flex>
          <div style={{ flex: 1 }}>
            <WhiteBoxBlock>
              <Typography.Title level={2} style={{ marginTop: "30px" }}>
                Дополнительная информация
              </Typography.Title>
              <Flex>
                <ItemInfoBlock items={getColumns(settings.rates)} vertical />
              </Flex>
              <VersionInfo />
            </WhiteBoxBlock>
          </div>
        </Flex>
      </Flex>
    </Flex>
  );
});
